import { SmartusComponentsModule } from '@affinis/smartus-components';
import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-welcome-pop',
  templateUrl: './welcome-pop.component.html',
  styleUrls: ['./welcome-pop.component.scss'],
  imports: [
    CommonModule,
    SmartusComponentsModule,
    TranslateModule,
    MatCheckboxModule,
    FormsModule,
  ],
})
export class WelcomePopComponent {
  readonly dialogRef = inject(MatDialogRef);
  readonly router = inject(Router);

  checkboxChecked = signal(false);
  isSubmitEnabled = computed(() => this.checkboxChecked() === true);

  get checkboxCheckedValue(): boolean {
    return this.checkboxChecked();
  }

  set checkboxCheckedValue(value: boolean) {
    this.checkboxChecked.set(value);
    if (value) {
      localStorage.setItem('welcomePop', 'true');
    } else {
      localStorage.removeItem('welcomePop');
    }
  }

  submitWelcomePopUp(): void {
    this.dialogRef.close();
  }

  redirectToLocation(): void {
    this.dialogRef.close();
    this.router.navigate(['/location/my-location']);
  }

  closeWelcomePopUp(): void {
    localStorage.removeItem('welcomePop');
    this.dialogRef.close();
  }
}
